import { render, staticRenderFns } from "./CadastroConfigNiveis.vue?vue&type=template&id=6ac551ee&scoped=true&class=template&"
import script from "./CadastroConfigNiveis.vue?vue&type=script&lang=js&"
export * from "./CadastroConfigNiveis.vue?vue&type=script&lang=js&"
import style0 from "./CadastroConfigNiveis.vue?vue&type=style&index=0&id=6ac551ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac551ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
